import * as React from 'react';
// import { any } from 'prop-types';

interface uploadFilesProps {
    filethumbnail?: any,
    filename?: any

}

class UploadFiles extends React.Component<uploadFilesProps> {
    render() {
        const {filethumbnail, filename } = this.props;
        return (
            <ul className="ec-project__uploaded-files">
                <li className="ec-project__uploaded-file">
                    <span className="ec-project__file-thumbnail"><img src={`/assets/images/projects/ ${filethumbnail}`} alt="" /></span>
                    <span className="ec-project__file-name">{filename}</span>
                </li>
            </ul>
        )
    }
}

export default UploadFiles;